import React from 'react';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';

import { Template } from './TemplateStyle';

export const PrimaryTemplate = props => {
    return (
        <Template className="flex-container-v">
            <HeaderNavComponent />
            {!props.hideBreadcrumb && <BreadcrumbComponent />}
            {props.children}
            <FooterComponent />
        </Template>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/PrimaryTemplate.js